export const dupLangHu = {
  dup: {
    title: 'Duplikáció kereső',
    subtitle: 'Ügyfél duplikációk keresése és összevonása',
    scan: 'Keresés indítása',
    scanning: 'Keresés folyamatban...',
    // Fields
    fieldEmail: 'E-mail',
    fieldPhone: 'Telefonszám',
    fieldTaxNumber: 'Adószám',
    fieldCompanyName: 'Cégnév',
    fieldFullName: 'Teljes név',
    // Confidence
    confidenceHigh: 'Magos',
    confidenceMedium: 'Közepes',
    confidenceLow: 'Alacsony',
    confidence: 'Egyezés',
    // Results
    results: 'Eredmények',
    noDuplicates: 'Nincs duplikáció',
    duplicatesFound: '{count} duplikáció találva',
    totalCustomers: 'Összes ügyfél',
    totalDuplicates: 'Érintett ügyfelek',
    scannedAt: 'Ellenőrizve',
    // Actions
    merge: 'Összevonás',
    ignore: 'Mellőzés',
    view: 'Megtekintés',
    // Merge modal
    mergeTitle: 'Ügyfelek összevonása',
    primary: 'Elsődleges (marad)',
    secondary: 'Másodlagos (törlődik)',
    selectPrimary: 'Válaszd ki melyik ügyfél maradjon',
    fieldByField: 'Mezőnkénti összevonás',
    keepPrimary: 'Elsődleges érték',
    keepSecondary: 'Másodlagos érték',
    confirmMerge: 'Összevonás megerősítése',
    mergeWarning: 'A másodlagos ügyfél véglegesen törlődik!',
    cancel: 'Mégse',
    // Real-time
    duplicateWarning: 'Lehetséges duplikáció!',
    duplicateFound: '{count} ügyfél található hasonló adatokkal',
    alreadyExists: 'Ezzel az adattal már létezik ügyfél',
  },
};
